import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SearchChangeEvent } from '@df/search/search.component.def';
import { ToggleService } from '@df/ui/toggle/toggle.service';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { AbstractCmsBlockComponent } from '../../cms/block/abstract-cms-block.component';
import { SEARCH_OUTLET_TOGGLE_ID } from '../outlet/search-outlet.component';
import { SearchComponent } from '../search.component';

export interface ISearchHeaderBlockContent extends NICmsContentComponent.IData {
    texts: {
        text: string;
    }[];
}

export const SEARCH_HEADER_BLOCK_ID = 'search-content-block';

@Component({
    selector: 'search-header',
    templateUrl: './search-header.component.html',
    styleUrl: './search-header.component.scss',
    standalone: true,
    imports: [SearchComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<SearchHeaderComponent>({
    id: SEARCH_HEADER_BLOCK_ID,
    block: {
        url: SEARCH_HEADER_BLOCK_ID
    },
    onDemandOnly: true,
    name: 'Search Header',
    description: 'Search box content',
    fields: [
        <NICmsContentField.IRepeaterField>{
            key: 'texts',
            type: NICmsContentField.EFieldType.repeater,
            title: 'Texts',
            itemName: 'Text',
            itemNameField: 'text',
            fields: [
                <NICmsContentField.IField>{
                    key: 'text',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Text'
                }
            ],
            default: []
        }
    ]
})
export class SearchHeaderComponent extends AbstractCmsBlockComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    override content!: ISearchHeaderBlockContent;

    readonly searchOutletToggleId = SEARCH_OUTLET_TOGGLE_ID;

    private toggleService = inject(ToggleService);

    onFocusChange(event: SearchChangeEvent) {
        if (event.value) {
            this.toggleService.open([this.searchOutletToggleId, 'header']);
        } else {
            this.close();
        }
    }

    close() {
        this.toggleService.close([this.searchOutletToggleId, 'header']);
    }
}
